// Tiny wrapper around gtag so the rest of the app doesn't have to null-check it.
// All event names follow GA4's snake_case convention.
//
// Public funnels we care about (GA4 Admin → Explore → Funnel):
//   1) Home  : page_view → message_submit → profile_complete → message_share
//   2) Engage: page_view → message_upvote
//   3) Viral : page_view (m/:id) → congratulate_click → message_share

export function track(eventName, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    window.gtag("event", eventName, params);
  } catch (e) {
    // never throw out of analytics
  }
}

/** Fire a manual page_view — needed for React Router SPA navigations. */
export function trackPageView(path, title) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    const location = typeof window !== "undefined" ? window.location.origin + path : path;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: location,
      page_title: title || (typeof document !== "undefined" ? document.title : undefined),
    });
  } catch (e) { /* never throw */ }
}

// Convenience wrappers — keeps call sites tidy & event names consistent.
export const Analytics = {
  // Legacy CM-poll funnel (still active on /previous-polls/kerala-cm-2026)
  voteCast: (candidate_id) => track("vote_cast", { candidate_id }),
  voteBlocked: (status) => track("vote_blocked", { status }),
  resultsView: (total_votes) => track("results_view", { total_votes }),
  languageToggle: (to) => track("language_toggle", { to }),
  formatToggle: (to) => track("format_toggle", { to }),
  revealToggle: (to) => track("reveal_toggle", { to }),

  // Kerala Speaks events
  messageSubmit: (category) => track("message_submit", { category }),
  messageUpvote: (message_id, source) => track("message_upvote", { message_id, source }),
  messageShare: (channel, source, format) => track("message_share", { channel, source, format }),
  congratulateClick: (message_id) => track("congratulate_click", { message_id }),
  profileComplete: (district, age_group, occupation, notify_opt_in) =>
    track("profile_complete", { district, age_group, occupation, notify_opt_in: !!notify_opt_in }),
  categoryFilter: (category) => track("category_filter", { category }),
  sortChange: (sort) => track("sort_change", { sort }),

  // Original share_click (still used inside the legacy ShareCard component)
  shareClick: (channel, mode, format) =>
    track("share_click", { channel, mode, format }),
};

export default Analytics;
